module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-text-fa5683d229cc8354030b6128dcb43d0d.svg";